import { render, staticRenderFns } from "./document-text.vue?vue&type=template&id=a6100dc2&"
import script from "./document-text.vue?vue&type=script&lang=js&"
export * from "./document-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6100dc2')) {
      api.createRecord('a6100dc2', component.options)
    } else {
      api.reload('a6100dc2', component.options)
    }
    module.hot.accept("./document-text.vue?vue&type=template&id=a6100dc2&", function () {
      api.rerender('a6100dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document-text.vue"
export default component.exports